var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.isVisible)?_c('upcoming-event',{attrs:{"id":"upcoming_event_unitTest"}}):_vm._e(),(_vm.isMember)?_c('community-officers-list',{staticClass:"panelBlock"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }